import React from 'react'
import notfound from "../assets/image/error.jpg"
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

export default function NoMatch() {
  const { user } = useSelector(state => state.auth)
  return (
    <section className='py-6 bg-primary'>
      <div className='mx-auto max-w-full px-5 lg:px-20'>
        <div>
          <Link className='text-xl' to={user?.role === "admin" ? "/admin/dashboard" : "/home"}>Go Home</Link>
        </div>
        <img className='w-1/2 mx-auto' src={notfound} alt="404_image" />
      </div>
    </section>
  )
}
